import clsx from "clsx";
import React from "react";
import { createUseStyles } from "$utils/createUseStyles";
import { styled } from "@mui/material/styles";
import Radio, { RadioProps } from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Divider from "@mui/material/Divider";
import { theme } from "$utils/theme/bataillog";

type Props = {
  name: string;
  radios: RadioValue[];
  onChange: (value: string) => void;
  defaultValue?: string;
  className?: string;
  withDivider?: boolean;
};

interface RadioValue {
  label: string;
  value: string;
  disabled?: boolean;
}

const StyledRadio = styled(Radio)({
  color: "blue",
  display: "none",
  "& + span": {
    padding: 10,
  },
  margin: 0,
  "&.Mui-checked": {
    "& + span": {
      color: "#fff",
      background: "#457DD9",
      borderRadius: 2,
    },
  },
});

const MyRadio = (props: RadioProps) => (
  <StyledRadio color="default" {...props} />
);

function RadioGrp({
  className = "",
  defaultValue,
  name,
  radios = [],
  onChange,
  withDivider = false,
}: Props) {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange((event.target as HTMLInputElement).value);
  };
  return (
    <RadioGroup
      className={clsx(classes.radioGrp, className)}
      aria-label={name}
      name={name}
      value={defaultValue}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
    >
      {radios.map((r, i) => (
        <div
          className={classes.radioItemContainer}
          key={`radio-option-${r.value}`}
        >
          {withDivider && i !== 0 && (
            <Divider orientation="vertical" className={classes.divider} />
          )}
          <FormControlLabel
            key={r.value}
            className={classes.controlLabel}
            value={r.value}
            control={<MyRadio />}
            label={r.label}
          />
        </div>
      ))}
    </RadioGroup>
  );
}

const useStyles = createUseStyles(() => ({
  radioGrp: {
    display: "flex !important",
    flexDirection: "row !important",
    border: "solid 1px #DFE1E6",
    width: "fit-content",
    borderRadius: 4,
  },
  controlLabel: {
    margin: "0 !important",
  },
  radioItemContainer: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
  },
  divider: {
    color: theme.color.gray2,
    "&.MuiDivider-vertical": {
      height: "50%",
    },
  },
}));

export default RadioGrp;
